import { useCallback, useRef } from 'react'
import { learningApi } from '../../services/api'
import {
  WrapperContainer,
  Modal,
  Wrapper,
  FooterAnnotation,
  TextNote,
  ButtonsAnnotattion,
} from './styles'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import Textarea from '../Textarea'
import { toast } from 'react-toastify'
import { AiOutlineClose } from 'react-icons/ai'
import { createModalPortal } from 'utils/createModalPortal'

interface TitleProps {
  title: string
  text: string
  annotationTime?: string
  close(): void
  refetchAnnotations?(): void
  type: 'doubt' | 'annotation'
  courseId: string
  moduleId: string
  videoId: string
  lessonId: string
  chapterId: string
  objectId?: string
  moduleName?: string
  teacherName?: string
  courseName?: string
  isText: boolean
  teacher?: string
  annotationId?: string
  textNote?: string
  isFreemium?: boolean
  handleSetTextNote?(string): void
  setOpenModalFreemium(status): void
}

const SenDoubt: React.FC<TitleProps> = ({
  title,
  text,
  annotationTime,
  close,
  refetchAnnotations,
  type,
  courseId,
  moduleId,
  videoId,
  lessonId,
  chapterId,
  objectId,
  moduleName,
  teacherName,
  courseName,
  isText,
  teacher,
  annotationId,
  textNote,
  handleSetTextNote,
  isFreemium,
  setOpenModalFreemium,
}) => {
  const token = localStorage.getItem('token')
  const formRef = useRef<FormHandles>()
  const teste = (e) => {
    if (e.target.id === 'modal') closeModal()
  }
  const closeModal = useCallback(() => {
    close()
  }, [close])
  const saveAnnotation = async (data) => {
    const reqData: any = {
      note: data.area,
    }

    if (annotationId) {
      await learningApi.patch(`/annotation/${annotationId}`, reqData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    } else {
      const reqBody = {
        note: data.area,
        text: data.text,
        color: data.color,
        course: { _id: courseId },
        module: { _id: moduleId },
        lesson: { _id: lessonId },
        chapter: { _id: chapterId },
        object: { _id: objectId },
        duration: annotationTime,
      }

      await learningApi.post(`/annotation/save-annotation`, reqBody, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    }

    refetchAnnotations()
  }

  const sendDoubt = async (data) => {
    await learningApi.post(
      '/asking/new',
      {
        course: {
          _id: courseId,
          name: courseName,
        },
        studyModule: {
          _id: moduleId,
          name: moduleName,
        },
        lesson: {
          _id: lessonId,
        },
        minimumApprenticeshipUnit: {
          _id: chapterId,
        },
        apprenticeshipObject: {
          _id: videoId,
        },
        objectType: isText ? 'excerpt' : 'video',
        professor: {
          _id: teacher,
          name: teacherName,
        },
        title: text ?? 'Pergunta do aluno',
        dialog: [
          {
            user: 0,
            answer: data.area,
          },
        ],
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  }

  const handleSaveAnnotation = async (data, { reset }) => {
    if (type === 'doubt') {
      if (isFreemium) {
        setOpenModalFreemium(true)
        reset()
        closeModal()
        return
      }
      sendDoubt(data)
    } else {
      saveAnnotation({ text, ...data, color: 'highlight-3' })
      refetchAnnotations()
    }
    reset()
    closeModal()
    toast.success(`${type === 'doubt' ? 'Dúvida enviada' : 'Anotação salva'} com sucesso`)
  }

  const handleChange = useCallback(
    (e: any): any => {
      handleSetTextNote(e.target.value)
    },
    [handleSetTextNote]
  )

  return createModalPortal(
    <WrapperContainer id="modal" onClick={teste}>
      <Modal>
        <Wrapper>
          {title}
          <button onClick={closeModal}>
            <AiOutlineClose size={25} />
          </button>
        </Wrapper>
        <hr id="line-one" />
        {!textNote ? <p>{text}</p> : <p> " {text} "</p>}
        <Form ref={formRef} onSubmit={handleSaveAnnotation} autoComplete="false">
          <Textarea
            name="area"
            defaultValue={textNote}
            onChange={() => handleChange}
            annotation="modal"
          />
          <hr id="line-two" />
          <FooterAnnotation>
            {type === 'doubt' && (
              <TextNote>
                <h5>
                  <b>Obs.:</b> O prazo de resposta é de até 05 dias úteis.
                </h5>
              </TextNote>
            )}
            <ButtonsAnnotattion>
              <button onClick={closeModal}>Cancelar</button>
              <button type="submit" className="save-button">
                Salvar
              </button>
            </ButtonsAnnotattion>
          </FooterAnnotation>
        </Form>
      </Modal>
    </WrapperContainer>
  )
}

export default SenDoubt
